import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { useDispatch } from "react-redux";
import { setLoading, setModal, setSnackbar } from "../../store/slices";
import { ModalKeys } from "../../components/modal/modalKeys";
import { TripMemberStatus } from "../../utils/enums/TripMemberStatus";
import { getTripDetails, tripMembershipAction, } from "../../services/api/TripDetailsService";
import { inviteUsersToTrip } from "../../services/api/EventCreationServices";
import useApiWrapper from "../../hooks/apiWrapper";
import FeaturedIn from "../../components/common/featured-in/featured-in";
import DetailsCard from "../../components/common/details-card/DetailsCard";
import TripActionButtons from "../../components/buttons/trip-actions/TripActionButtons";
import { CustomIcon, HorizontalRule, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
import { TripDetailsBody } from "./trip-details.style";
import CheckIcon from "@mui/icons-material/Check";
import { IosShareOutlined } from "@mui/icons-material";
import TripStatus from "../../components/common/trip-status/TripStatus";
import TripPrivacyCard from "../../components/common/trip-privacy/TripPrivacyCard";
import InfoListCard from "../../components/common/infoList-card/InfoListCard";
import TripItineraryCard from "../../components/common/trip-itinerary/TripItineraryCard";
import TripCoverBanner from "../../components/common/trip-cover-banner/TripCoverBanner";
var TripDetails = function () {
    var _a, _b, _c, _d;
    var dispatch = useDispatch();
    var tripId = useParams().tripId;
    var _e = useState(null), trip = _e[0], setTripDetails = _e[1];
    var _f = useState(TripMemberStatus.NOT_JOINED), userStatus = _f[0], setUserStatus = _f[1];
    var _g = useState(false), actionLoading = _g[0], setActionLoading = _g[1];
    var apiWrapper = useApiWrapper().apiWrapper;
    // Fetch Trip Details
    var fetchTripDetails = function (tripId) { return __awaiter(void 0, void 0, void 0, function () {
        var res, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setLoading(true));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getTripDetails(tripId)];
                case 2:
                    res = _a.sent();
                    setTripDetails(res);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error("Error fetching trip details:", err_1);
                    dispatch(setSnackbar({
                        message: "Failed to fetch trip details",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setLoading(false));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var submitInviteUsers = function (tripId, payload) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, apiWrapper(function () { return inviteUsersToTrip(tripId, payload); })];
                case 1:
                    _a.sent();
                    dispatch(setSnackbar({
                        message: "Invites sent successfully",
                        severity: "success",
                        open: true,
                    }));
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    dispatch(setSnackbar({
                        message: "Some issue occurred",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    dispatch(setLoading(false));
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleInviteUsersClick = function () {
        dispatch(setModal({
            name: ModalKeys.INVITE_USERS,
            props: {
                trip: trip,
                tripId: tripId,
                tripName: trip === null || trip === void 0 ? void 0 : trip.tripName,
                onSubmit: submitInviteUsers,
            },
        }));
    };
    var handleTripMembershipAction = function (tripId, action) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setActionLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, apiWrapper(function () {
                            return tripMembershipAction({ tripId: tripId, action: action });
                        })];
                case 2:
                    res = _a.sent();
                    if (res.result && res.result.updatedStatus) {
                        setUserStatus(res.result.updatedStatus);
                    }
                    dispatch(setSnackbar({
                        message: res.message,
                        severity: [2107, 2112].includes(res.statusCode) ? "success" : "error",
                        open: true,
                    }));
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error(error_2);
                    dispatch(setSnackbar({
                        message: "Some issue occurred",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    setActionLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (trip) {
            setUserStatus(trip.userStatus);
        }
    }, [trip]);
    useEffect(function () {
        if (tripId)
            fetchTripDetails(tripId);
    }, []);
    return (_jsx(WrapperContainer, { "$margin": "0", "$padding": "0", children: trip && (_jsxs(WrapperContainer, { "$flexDirection": "column", "$padding": "0 1rem 1rem 1rem", children: [_jsx(TripCoverBanner, { trip: trip }), _jsxs(TripDetailsBody, { children: [_jsxs(WrapperContainer, { "$justifyContent": "space-between", "$padding": "0", "$responsive": false, children: [_jsx(FeaturedIn, { categories: trip.tripCategories }), _jsx(TripStatus, { status: trip.status })] }), _jsx(HorizontalRule, {}), _jsx(DetailsCard, { title: "Trip Overview", description: trip.description, tripData: trip }), _jsx(TripPrivacyCard, { privacy: trip === null || trip === void 0 ? void 0 : trip.privacySetting }), trip.highlights && trip.highlights.length > 0 && (_jsx(InfoListCard, { title: "Trip Highlights", sections: [
                                {
                                    items: trip.highlights,
                                    icon: _jsx(CheckCircleOutline, { sx: { fontSize: 20 } }), // Blue outline check
                                    iconColor: "#1976d2",
                                },
                            ] })), (((_b = (_a = trip.inclusions) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0 ||
                            ((_d = (_c = trip.exclusions) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0) && (_jsx(InfoListCard, { title: "What's Included & Excluded", sections: [
                                {
                                    subtitle: "Inclusions",
                                    items: trip.inclusions || [],
                                    icon: _jsx(CheckIcon, { sx: { fontSize: 20 } }), // Green solid check
                                    iconColor: "#4caf50",
                                },
                                {
                                    subtitle: "Exclusions",
                                    items: trip.exclusions || [],
                                    icon: (_jsx(CloseOutlined, { sx: { fontSize: 20, fontWeight: "bold" } })), // Red cross
                                    iconColor: "#d32f2f",
                                },
                            ] })), trip.itinerary && trip.itinerary.length > 0 && (_jsx(TripItineraryCard, { itinerary: trip.itinerary }))] }), _jsxs(WrapperContainer, { "$display": "flex", "$position": "sticky", "$padding": "1rem 1rem", "$bottom": "0", "$margin": "0 0 0 -1rem", "$width": "calc(100% + 2rem)", "$backgroundColor": "white", "$boxShadow": "1px -2px 7px 3px rgba(0, 0, 0, 0.1)", "$responsive": false, children: [_jsx(CustomIcon, { "$fontSize": "inherit", "$backgroundColor": "#d9dfe9", "$borderRadius": "16px", "$width": "10%", "$padding": "0.75rem", "$alignItems": "center", onClick: handleInviteUsersClick, children: _jsx(IosShareOutlined, { color: "action", fontSize: "small" }) }), _jsx(TripActionButtons, { tripPrivacy: trip.privacySetting, userStatus: userStatus, actionLoading: actionLoading, onAcceptInvite: handleTripMembershipAction.bind(null, tripId || "", "ACCEPT_INVITE"), onDeclineInvite: handleTripMembershipAction.bind(null, tripId || "", "DECLINE_INVITE"), onJoin: handleTripMembershipAction.bind(null, tripId || "", "JOIN"), onRequestJoin: handleTripMembershipAction.bind(null, tripId || "", "REQUEST_JOIN"), onCancelRequestJoin: handleTripMembershipAction.bind(null, tripId || "", "CANCEL_REQUEST"), onLeave: handleTripMembershipAction.bind(null, tripId || "", "LEAVE") })] })] })) }));
};
export default TripDetails;
